<template>
	<div class="background">
		<div class="container">

			<div class="alerts-panel">
				<alert v-for="alert in alerts" 
					:key="alert.timestamp+alert.message" 
					:classes="alert.class"
					:visible="alert.visible"
					:errors="alert.errors"
					:icon="alert.icon"
					:message="alert.message"
					:self-clear="alert.selfClear"
					v-on:close="closeAlert(alert.timestamp)">
				</alert>

				<a v-if="alerts.length > 1" href="#" v-on:click.prevent="clearAlerts">Clear All Alerts</a>
			</div>

			<form v-on:submit.prevent="authenticate" class="login-form">
				<div>
					<img :src="logoSrc">
				</div>

				<template v-if="mfa_step == 'prompt-email-password'">
					<h1>SIGN IN</h1>

					<input type="email" 
						name="email" 
						placeholder="Email" 
						class="form-control" 
						v-model="payload.email" 
						style="margin-bottom: -1px;">

					<input v-if="'partnerAccess' in $route.params && $route.params.partnerAccess == 'partner-access'" 
						type="email" 
						name="channel_partner_email" 
						class="form-control" 
						v-model="payload.channel_partner_email"
						placeholder="Channel Partner Email" 
						style="margin-bottom: -1px;">

					<input type="password" name="password" placeholder="Password" class="form-control" v-model="payload.password">

					<div>
						<label>
							<input type="checkbox" v-model="staySignedIn">
							Stay signed in on this device
						</label>
					</div>

					<alert	
						:message="alert.message" 
						:icon="alert.icon" 
						:visible="alert.visible"
						:classes="alert.class"
						v-on:close="alert.visible = false">	
					</alert>

					<button type="submit" class="btn btn-primary">
						<i class="fa fa-sign-in-alt"></i>
						Login
					</button>

					<p class="forgot-password"><a href="#" v-on:click.prevent="passwordResetRequest">I forgot my password</a></p>
				</template>
				<div v-else-if="mfa_step == 'prompt-code-destination'" class="mt-4">
					
					<p>Two-factor authentication required. Please choose where to receive your 2-factor code:</p>

					<ul class="list-group">
						<li class="list-group-item list-group-item-action"
							v-on:click="chooseMfaDestination('email')">
							Email: {{ authResponseDetails.email }}
						</li>
						<li v-if="authResponseDetails.phone_mobile" class="list-group-item list-group-item-action"
							v-on:click="chooseMfaDestination('sms')">
							SMS: {{ authResponseDetails.phone_mobile }}
						</li>
					</ul>

				</div>
				<div v-else-if="mfa_step == 'enter-code'" class="mt-4 mfa-enter-code text-left">

					<div class="card shadow-sm border mfa-code-card mx-auto">
						<div class="card-body p-4">

							<h2 class="h5 mb-2">Enter verification code</h2>
							<p class="text-muted small mb-4">
								Enter the 6-character code we sent to the email or number you chose.
								Codes expire after one hour. You can paste the code or type it, then press Submit.
							</p>
							<p>Letter case does not matter.</p>

							<field label="Verification code" col-class="stacked"
								:params="{
									type: 'text',
									required: true,
									placeholder: '6-character code',
									autocomplete: 'one-time-code'
								}"
								v-model="mfaCode"
								v-on:change="submitMfaCode">
							</field>

							<div class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-stretch align-items-sm-center mt-4 pt-3 border-top">
								<button type="button" class="btn btn-link px-0 text-left order-2 order-sm-1 mt-2 mt-sm-0"
									v-on:click="mfaBackToLogin">
									Back to Login
								</button>
								<button type="button" class="btn btn-primary order-1 order-sm-2"
									v-on:click="submitMfaCode">
									Submit
								</button>
							</div>

						</div>
					</div>

				</div>
			</form>
			
			<modal-dialog
				title="Password Reset Request" 
				:modal-visible="resetRequest.visible" 
				confirm-button-text="Submit"
				:submit-visible="resetRequest.submitVisible"
				:cancel-button-text="resetRequest.cancelButtonText"
				v-on:confirm="submitResetRequest"
				v-on:closeModal="resetRequest.visible = false">

				<div v-if="!resetAlert.visible">

					<p>Enter your email and a password reset link will be sent to you.</p>
					
					<field label="Your Email" col-class="col-md-4"
						:params="{type:'email',required:true}"
						v-model="resetRequest.email">
					</field>

					<field label="Notification type" col-class="col-md-4"
						:params="{type:'boolean',doubleLabels:['Email','SMS']}"
						v-model="resetRequest.smsNotification">
					</field>
				</div>

				<div class="alert"
					v-if="resetAlert.visible"
					:class="resetAlert.class">
					{{resetAlert.msg}}
				</div>

			</modal-dialog>
		</div>
	</div>
</template>

<script>
import Alert from "@/components/Alert"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"

import AppStartup from "@/mixins/AppStartup.js"

export default {

	name: 'Login',
	components: {
		Alert,
		Field,
		ModalDialog
	},
	mixins: [AppStartup],
	data() {
		return {
			payload: {
				email: "",
				password: ""
			},
			mfa_step: 'prompt-email-password',
			authResponseDetails: null,
			mfaCode: null,
			mfaCodeSubmitted: false,
			mfaCodeSubmittedResetTimeout: null,
			alert: {
				class: "alert-warning",
				message: "Logging in...",
				icon: "fa-spinner fa-spin",
				visible: false
			},
			staySignedIn: true,
			resetRequest : {
				visible: false,
				email: "",
				smsNotification: false, 
				submitVisible: true,
				cancelButtonText: "Cancel"
			},
			resetAlert: {
				msg: "",
				visible: false,
				class: ""
			},
			alerts: []
		}
	},
	computed: {
		logoSrc() {
			return window.apiRoot+"resources/logo-800.png?v=2021-11-26"
		}
	},
	methods: {
		handleSuccessulAuth(response) {
			let vm = this

			vm.alert.visible = true
			vm.alert.message = "Success! Redirecting...";
			vm.alert.icon = "fa-check";
			vm.alert.class = "alert-success"

			localStorage.apiKey = response.data.api_key

			localStorage.sessionToken = JSON.stringify(response.data.session_token)

			//if stay signed in was checked, record this to localStorage
			if (vm.staySignedIn) 
				localStorage.staySignedIn = true

			if ("activateAccountSetupMode" in response.data)
				vm.$store.accountSetupMode = response.data.activateAccountSetupMode
			if ("activateCompanySetupMode" in response.data)
				vm.$store.companySetupMode = response.data.activateCompanySetupMode

			vm.$bus.$emit("updateUserPermissions",response.data)
			vm.$bus.$emit("loginStatus",true)
			vm.$bus.$emit("messagePollRequest")

			vm.showNotificationPrompt()
			vm.registerOneSignalId()

			if (vm.$store.companySetupMode)
				vm.$router.push("/setup")
			else if ("partnerAccess" in vm.$route.params && vm.$route.params.partnerAccess == 'partner-access')
				vm.$router.push("/")
		} ,
		authenticate() {
			let vm = this

			this.alert.visible = true
			this.alert.message = "Logging in..."
			this.alert.icon = "fa-spinner fa-spin"
			this.alert.class = "alert-info"

			this.postData("user/authenticate", this.payload).then(response => {

				vm.alert.visible = false

				if (response.success == true) {

					if ("mfaRequired" in response.data && response.data.mfaRequired) {
						vm.mfa_step = 'prompt-code-destination'
						vm.authResponseDetails = response.data
					}
					else {
						vm.handleSuccessulAuth(response)
					}
				}
				else {
					vm.alert.visible = true
					vm.alert.icon = "fa-times";
					vm.alert.class = "alert-danger"
					if ("errors" in response && response.errors.length > 0 && response.errors[0] != "Request failed") {
						vm.alert.message = response.errors[0]
					}
					else 
						vm.alert.message = "Incorrect credentials";
				}
			})
		},
		clearMfaCodeSubmittedGuard() {
			if (this.mfaCodeSubmittedResetTimeout != null) {
				clearTimeout(this.mfaCodeSubmittedResetTimeout)
				this.mfaCodeSubmittedResetTimeout = null
			}
			this.mfaCodeSubmitted = false
		},
		chooseMfaDestination(destination) {
			let payload = {
				email: this.payload.email,
				destination,
			}

			this.postData("User/send-mfa-code",payload)

			this.clearMfaCodeSubmittedGuard()
			this.mfa_step = 'enter-code'
		},
		mfaBackToLogin() {
			this.clearMfaCodeSubmittedGuard()
			this.mfa_step = 'prompt-email-password'
		},
		submitMfaCode() {
			let vm = this 

			if (vm.mfaCodeSubmitted)
				return

			vm.mfaCodeSubmitted = true
			vm.mfaCodeSubmittedResetTimeout = setTimeout(() => {
				vm.mfaCodeSubmitted = false
				vm.mfaCodeSubmittedResetTimeout = null
			}, 2000)

			let payload = {
				email: this.payload.email,
				password: this.payload.password,
				mfa_code: this.mfaCode
			}

			this.postData("User/authenticate",payload).then(response => {
				if (response.success) 
					vm.handleSuccessulAuth(response)
				else 
					vm.alertFail("Incorrect code")
			})
		},
		passwordResetRequest() {
			this.resetRequest.visible = true
			this.resetAlert.visible = false;
			this.resetRequest.cancelButtonText = "Cancel"
			this.resetRequest.submitVisible = true
			this.$nextTick(() => this.$refs.emailReset.focus())
			//this.$refs.emailReset.$el.focus()
		},
		submitResetRequest() {
			let vm = this
			let payload = {
				email: this.resetRequest.email,
				smsNotification: this.resetRequest.smsNotification
			}
			this.postData("user/reset-request",payload).then(function(response){
				vm.resetAlert.visible = true;

				if (vm.resetRequest.smsNotification)
					vm.resetAlert.msg = "Please check your mobile phone SMS messages for password reset instructions"
				else
					vm.resetAlert.msg = "Please check your email for password reset instructions"
				
				vm.resetAlert.class = "alert-success"

				vm.resetRequest.cancelButtonText = "Done"
				vm.resetRequest.submitVisible = false

				vm.resetRequest.email = ""
			})
		}

	},
	created() {
		this.spinner(false)

		this.$bus.$on("pushAlert",this.onPushAlert)
	},
	beforeDestroy() {
		this.clearMfaCodeSubmittedGuard()
	}

}
</script>

<style scoped>
	form.login-form {
		text-align: center;
		max-width: 500px;
		margin: auto;
		margin-top: 20px;
		margin-bottom: 20px;
		padding: 20px;
		/*box-shadow: 0 0 10px grey;
		background-color: white;*/
	}

	h1 {
		font-size: 24pt;
		margin-top: 30px;
	}

	input {
		margin-bottom: 10px;
	}

	.forgot-password {
		margin-top: 20px;
		margin-bottom: -10px;
	}

	.background {
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		/*background-color: #404040;*/
		display: flex;
		align-items: center;
	}

	@media (max-width: 400px) {
		form.login-form {
			box-shadow: none;
			padding: 10px;
		}
	}

	.mfa-code-card {
		max-width: 420px;
	}
</style>
